(function ($) {

    $(function () {

        $("#newsListCategoryFilterSelected").click(function () {
            $(".category-filter").toggleClass("expanded");
            $("#newsListCategoryFilterBody").slideToggle(300);
        });

        $("#newsListCategoryFilterClear").click(function () {
            $("#newsList2024CategoryFilter").find("input[name=\"selectedNewsCategory\"]").prop("checked", false);
        });

        $("#newsListCategoryFilterApply").click(function () {

            var currentLocation = window.location.href;
            var newLocation = new URL(currentLocation);

            newLocation.searchParams.delete("page");

            var $selectedCategories = $("input[name=\"selectedNewsCategory\"]:checked");
            if ($selectedCategories.length <= 0) {
                newLocation.searchParams.delete("category");
            }
            else if ($selectedCategories.length > 0) {
                newLocation.searchParams.set("category", $selectedCategories.val());
            }
            window.location = newLocation.href;

        });

    });

})($JQ);
